import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useGetRemoteServiceWrapper } from '../../../hooks/RemoteServiceHooks';
import { useDomain } from '../../../../states/AppDomainProvider';
import ButtonWithSpinner from '../../../../components/buttons/ButtonWithSpinner';
import Logger from '../../../../utils/Logger';
import { addToGroupPlay } from '../../../../services/GroupPlayService';

import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessons: [],
  selectedLessonIds: [],
  onSaveSuccess: () => { },
};

export default function LessonsAddToGroupPlay(p) {
  const { lessons, selectedLessonIds, onSaveSuccess } = { ...defaultProps, ...filterUndefined(p) };
  const { loading: saving, callRemoteServiceWrapper } = useGetRemoteServiceWrapper();
  const { userDomain, uiDomain } = useDomain();
  const { user } = userDomain.domainData;

  const selectedLessons = [];
  lessons.forEach((l) => {
    if (selectedLessonIds.includes(l.id)) {
      selectedLessons.push(l);
    }
  });

  const handleOnClick = async () => {
    try {
      await callRemoteServiceWrapper(async () => {
        await addToGroupPlay(user.id, selectedLessonIds);
        selectedLessons.forEach((s) => {
          let { meta } = s;
          if (!meta) {
            meta = {};
          }
          meta.groupPlay = true;
          // eslint-disable-next-line no-param-reassign
          s.meta = meta;
        });
        onSaveSuccess(lessons);
      });
      await uiDomain.showSnackbar(true, 'success', 3000, `The ${selectedLessonIds.length === 1 ? 'activity is' : 'activities are'} added to the Group Instruction succesfully.`);
    } catch (e) {
      Logger.logError(e);
    }
  };

  return (
    <ButtonWithSpinner
      variant='contained'
      className='btn-primary'
      disabled={!selectedLessons || selectedLessons.length === 0}
      onClick={handleOnClick}
      startIcon={<AddCircleIcon />}
      data-test='lessons-add-to-group-play-action'
      label='Add to Group Instruction'
      loading={saving}
    />
  );
}
